import React from 'react';
import RadioOff from '@strava/icons/ActionsRadioOffSmall';
import RadioOn from '@strava/icons/ActionsRadioOnSmall';
import colors from '../colors';
import styles from './styles.scss';

var Radio = function Radio(_ref) {
  var id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      color = _ref.color,
      checked = _ref.checked,
      disabled = _ref.disabled,
      className = _ref.className,
      onChange = _ref.onChange;
  var classNames = [styles.radio, className];
  return /*#__PURE__*/React.createElement("span", {
    className: classNames.join(' '),
    role: "radio",
    "aria-checked": checked,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: id,
    name: name,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    tabIndex: -1
  }), checked ? /*#__PURE__*/React.createElement(RadioOn, {
    fill: color
  }) : /*#__PURE__*/React.createElement(RadioOff, null));
};

Radio.defaultProps = {
  color: colors.O50_STRAVA_ORANGE,
  checked: false,
  disabled: false,
  className: null,
  onChange: function onChange() {}
};
export default Radio;